import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import type { TaskHistoryItem, TaskStats } from "@/types/task";

const REFETCH_MS = 5_000;

export function useTaskHistory(status: string) {
  return useQuery({
    queryKey: ["tasks", "history", status],
    queryFn: () => {
      const url = status === "all" ? "/tasks/" : `/tasks/?status=${status}`;
      return api<TaskHistoryItem[]>(url);
    },
    refetchInterval: REFETCH_MS,
  });
}

export function useTaskStats() {
  return useQuery({
    queryKey: ["tasks", "stats"],
    queryFn: () => api<TaskStats>("/tasks/stats"),
    refetchInterval: REFETCH_MS,
  });
}
